import { store } from 'v3/data/store';
import { ContractingStateEnum } from 'v3/data/store/contracting/enums';
import { filtersInitialState } from 'v3/data/store/contracting/state';
import { IStoreItem } from 'v3/data/store/stores/types';
import { contractingSlice } from '.';
import { ContractingListType, ContractingListViewType, ContractingType, FiltersType } from './types';

export const setContractingList = (list: ContractingListType) => {
  store.dispatch(contractingSlice.actions.setContractingList(list));
};

export const setContractingViewList = (list: ContractingListViewType) => {
  store.dispatch(contractingSlice.actions.setContractingViewList(list));
};

export const setFilters = (filters: FiltersType) => {
  store.dispatch(contractingSlice.actions.setFilters(filters));
};

export const setStoreIdssList = (storeIdsList: string[]) => {
  store.dispatch(contractingSlice.actions.setStoreIdsList(storeIdsList));
};

export const setIsCustomDate = (value: boolean) => {
  store.dispatch(contractingSlice.actions.setIsCustomDate(value));
};

export const clearFilters = (options?: { keepStoreIds?: boolean }) => {
  if (options?.keepStoreIds) {
    const currentStoreIds = store.getState().contracting.filter.storeIds;
    const newFilters = {
      ...filtersInitialState,
      storeIds: currentStoreIds,
    };
    store.dispatch(contractingSlice.actions.setFilters(newFilters));
    return;
  }
  store.dispatch(contractingSlice.actions.setFilters(filtersInitialState));
};

export const setFilterCurrentPage = (value: number) => {
  store.dispatch(contractingSlice.actions.setFilterCurrentPage(value));
};

export const setFilterRowsPerPage = (value: number) => {
  store.dispatch(contractingSlice.actions.setFilterRowsPerPage(value));
};

export const setFilterRowsToSkip = (value: number) => {
  store.dispatch(contractingSlice.actions.setFilterRowsToSkip(value));
};

export const setContractingKey = (value: string) => {
  store.dispatch(contractingSlice.actions.setContractingKey(value));
};

export const setContractingState = (value: ContractingStateEnum) => {
  store.dispatch(contractingSlice.actions.setContractingState(value));
};

export const setTokenValid = (tokenValid: boolean) => {
  store.dispatch(contractingSlice.actions.setTokenValid(tokenValid));
};

export const setContractingSelected = (contracting: ContractingType) => {
  store.dispatch(contractingSlice.actions.setContractingSelected(contracting));
};

export const setTimeRemaining = (timeRemaining: string) => {
  store.dispatch(contractingSlice.actions.setTimeRemaining(timeRemaining));
};

export const setStoreIdsListFilter = (storeIdsList: string[]) => {
  store.dispatch(contractingSlice.actions.setStoreIdsList(storeIdsList));
};

export const setContractSignDate = (contractSignDate: string) => {
  store.dispatch(contractingSlice.actions.setContractSignDate(contractSignDate));
};

export const setTotalContractings = (totalContractings: number) => {
  store.dispatch(contractingSlice.actions.setTotalContractings(totalContractings));
};

export const setAllStoresIds = (list: IStoreItem[]) => {
  store.dispatch(contractingSlice.actions.setAllStoresIds(list));
};

export const setInitialStoreIdsRequest = (initialStoreIdsRequest: boolean) => {
  store.dispatch(contractingSlice.actions.setInitialStoreIdsRequest(initialStoreIdsRequest));
};
